import React from 'react';
import * as Yup from 'yup';
import { FormContainer } from '~/views/roles/styles';
import { Checkbox, InputGroup, CurrencyField } from '~/components/form';

export const RoleSchema = Yup.object().shape({
  name: Yup.string().min(4, 'Verifique se o nome está correto').required('Informe o nome'),
});

export const RoleForm = ({ errors, touched, previewMode }) => {

  return (
    <FormContainer>
      <Checkbox name='active' label='Ativa' />

      <InputGroup
        type="text"
        name="name"
        label="Nome"
        maxLength={100}
        disabled={previewMode}
        hasError={errors.name && touched.name} />

      <CurrencyField
        disabled={previewMode}
        name="value"
        label="Valor"
        hasError={errors.value && touched.value} />

    </FormContainer>
  );
};
